module.exports = __webpack_public_path__ + "img/app_code.5bb10352.png";